import { Actions, ActionTypes } from '@appStore/learning/actions';
import { InformationVideoCategory } from '@model';

export interface State {
  loading: boolean;
  loaded: boolean;
  data: InformationVideoCategory[];
}

export const initialState: State = {
  loading: false,
  loaded: false,
  data: null
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    
    case ActionTypes.InformationVideosLoad:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.InformationVideosLoadSuccess:
      return {
        ...state,
        loaded: true,
        loading: false,
        data: action.payload
      };

    case ActionTypes.InformationVideosLoadFail:
      return { ...state, loaded: false, loading: false };
  }
  return state;
}

export const getAll = (state: State) => state.data;
export const getLoaded = (state: State) => state.loaded;
export const getLoading = (state: State) => state.loading;

